const namespaced = true;

const state = {
  nodes: [],
  savedNodes: [],
  links: [],
  canvas: null,
  anchors: {}
};

const mutations = {
  createCanvas(state, canvas) {
    state.canvas = canvas;
  },
  addNode(state, node) {
    state.nodes.push(node);
  },
  addSavedNode(state, node){
    state.savedNodes.push(node);
  },
  removeSavedNode(state, node){
    const listIds = state.savedNodes.map((x) => x._id);
    const idNode = node._id;
    let indexNode = 0;
    for (let i=0; i<listIds.length; i++){
      if (listIds[i] === idNode){
        indexNode = i;
        break;
      }
    }
    state.savedNodes.splice(indexNode, 1);
  },
  resetCanvas(state) {
    state.canvas = null;
    state.nodes = [];
    state.links = [];
  },
  addAnchor(state, { id, data }) {
    state.anchors[id] = data;
  },
  updateAnchor(state, { id, key, value }) {
    state.anchors[id][key] = value;
  }
};

const actions = {
  createCanvas({ commit }, canvas) {
    commit('createCanvas', canvas);
  },
  addNode({ commit }, node) {
    commit('addNode', node);
  },
  addSavedNode({ commit }, node){
    commit('addSavedNode', node);
  },
  removeSavedNode({ commit }, node){
    commit('removeSavedNode', node);
  },
  resetCanvas({ commit }) {
    commit('resetCanvas');
  }
};

export default { state, mutations, actions, namespaced };
